import { createApi, fetchBaseQuery, BaseQueryFn, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react';
import { setCredentials, logOut } from '../slices/authSlice';
import { RootState } from '../RootState';
// import { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import type { QueryReturnValue } from '@reduxjs/toolkit/query';
import { ApiResponse } from '../../types/apiResponse';
import { notifications } from '@mantine/notifications';

const token = sessionStorage.getItem('token');
const refreshToken = sessionStorage.getItem('refreshToken');
const BASE_URL = import.meta.env.VITE_DOC_APP_API_URL;

type BaseQueryArgs = string | Parameters<typeof baseApiQuery>[0];
type BaseQueryResponse = ApiResponse;
const customFetch = (input: RequestInfo, init?: RequestInit) => {
  // Implement your custom fetch logic here
  return fetch(input, init);
};
const baseApiQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  fetchFn: customFetch,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
      // sessionStorage.setItem('hasAnimationPlayed', 'true');
    }
    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<BaseQueryArgs, BaseQueryResponse, Parameters<typeof baseApiQuery>[2]> = async (args, api, extraOptions) => {
  let result = await baseApiQuery(args, api, extraOptions) as QueryReturnValue<ApiResponse, FetchBaseQueryError, FetchBaseQueryMeta>;
  const responseStatus = result.data?.succeeded;

  if(result.error?.status === 400 && responseStatus === undefined)
  {
    const errorData = result.error?.data as { errors?: Record<string, string[]> };
    if (errorData?.errors) {
      Object.entries(errorData.errors).forEach(([errorKey, errorValues]) => {
        notifications.show({
          autoClose: 3000,
          title: `Error in ${errorKey}` ,
          message: errorValues.join(', '),
          color: 'red',
        });
      });
    }
  }
  // if(responseStatus === false)
  // {
  //   notifications.show({
  //     autoClose: 5000,
  //     title: "Error",
  //     message: result.data?.messages,
  //     color: 'red',
  //   });
  // }
  if (result?.error?.status === 403) {
    const refreshResult = await baseApiQuery('/identity/token/refresh', api, {
      ...extraOptions,
      method: 'POST',
      body: JSON.stringify({ token, refreshToken }),
    });
    if (refreshResult?.data) {
      const user = (api.getState() as RootState).auth.user;
      api.dispatch(setCredentials({ ...refreshResult.data, user }));
      result = await baseApiQuery(args, api, extraOptions) as QueryReturnValue<ApiResponse, FetchBaseQueryError, FetchBaseQueryMeta>;
    } else {
      api.dispatch(logOut());
    }
  }

  return result;
};

export const securedAppApi = createApi({
  reducerPath: 'securedAppApi',
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});

